import { isNumber, isObject, isString } from 'radash';

export interface BaseEntity {
  readonly id: string;
  readonly updatedAt: number;
  readonly isDeleted: boolean;
  readonly version: number;
}

export function isBaseEntity(obj: unknown): obj is BaseEntity {
  if (!isObject(obj)) return false;
  const possible = obj as BaseEntity;
  if (!isString(possible.id)) return false;
  if (!isNumber(possible.updatedAt)) return false;
  if (!(possible.isDeleted === true || possible.isDeleted === false)) return false;
  if (!isNumber(possible.version)) return false;

  return true;
}
